var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{ref:"image",staticClass:"mx-auto d-block"}),_c('input',{ref:"input",staticClass:"form-input",attrs:{"type":"file","name":"image","accept":_vm.acceptedTypes,"required":_vm.isRequired,"disabled":_vm.disabled},on:{"input":_vm.onFileInput}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }